import _toConsumableArray from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _ref;
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.push.js";
import Vue from 'vue';
import Router from 'vue-router';
import { broadcast } from '@/utils/broadcast';
import { REDIRECTS } from '@/router/routerSchema';
import store from '@/store';
Vue.use(Router);

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export var asyncRoutes = [];
export var constantRoutes = [{
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/help2',
  class: 'bottom-30',
  component: function component() {
    return import('@/views/help/HelpView');
  },
  isGuestView: false,
  name: 'invite',
  meta: {
    title: 'Invite',
    short: 'Invite',
    icon: 'fal fa-user-circle'
  }
}, (_ref = {
  path: '/apps',
  component: function component() {
    return import('@/views/apps/index');
  },
  name: 'apps',
  isGuestView: false
}, _defineProperty(_ref, "name", 'apps'), _defineProperty(_ref, "meta", {
  title: 'Apps',
  short: 'Apps',
  icon: 'kv-icon-help'
}), _defineProperty(_ref, "children", [{
  path: 'list',
  component: function component() {
    return import('@/views/apps/appList');
  },
  name: 'apps.list',
  meta: {
    title: 'Apps',
    short: 'Apps',
    icon: 'kv-icon-help'
  }
}]), _ref), {
  path: '/help',
  class: 'bottom-0',
  component: function component() {
    return import('@/views/help/HelpView');
  },
  isGuestView: false,
  name: 'help',
  meta: {
    title: 'Help',
    short: 'Help',
    icon: 'kv-icon-help'
  },
  children: [{
    path: 'open-customer-portal',
    component: function component() {
      return import('@/views/help/knowledge-base/KnowledgeBaseList');
    },
    name: 'help.open-customer-portal',
    class: 'bottom-0',
    meta: {
      title: 'Help',
      short: 'Help',
      icon: 'kv-icon-help'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              new KivaProxy({
                endpoint: "../support/client/sso?getUrl=1",
                driver: 'base'
              }).all().then(function (response) {
                // console.log("response",response)
                if (response && response.url) {
                  // window.location.href = response.url
                  // window.location.href = response.url
                  var url = response.url;
                  store.state.common.HELP_DRAWER = {
                    visible: true,
                    path: url
                  };
                }
              }).catch(function (err) {});
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }, {
    path: 'knowledge-base',
    component: function component() {
      return import('@/views/help/knowledge-base/KnowledgeBaseList');
    },
    name: 'help.knowledge-base',
    meta: {
      title: 'Help',
      short: 'Help',
      icon: 'kv-icon-help'
    }
  }, {
    path: 'knowledge-base/ticket',
    hidden: true,
    component: function component() {
      return import('@/views/help/knowledge-base/KnowledgeBaseTicket');
    },
    name: 'help.knowledge-base.ticket',
    meta: {
      title: 'Knowledge Base Ticket',
      icon: 'fal fa-books'
    }
  }, {
    path: 'knowledge-base/ticket/:id',
    props: true,
    hidden: true,
    component: function component() {
      return import('@/views/help/knowledge-base/KnowledgeBaseTicketDetail');
    },
    name: 'help.knowledge-base.ticket.detail',
    meta: {
      title: 'Knowledge Base Ticket',
      icon: 'fal fa-books'
    }
  }, {
    path: 'knowledge-base/:id',
    hidden: true,
    component: function component() {
      return import('@/views/help/knowledge-base/KnowledgeBaseDetail');
    },
    name: 'help.knowledge-base.detail',
    props: true,
    meta: {
      hideTag: true,
      noCache: true,
      title: 'Knowledge Base',
      icon: 'fal fa-books'
    }
  }]
}, {
  path: '/account',
  component: function component() {
    return import('@/views/account/AccountView');
  },
  isGuestView: true,
  name: 'account',
  hidden: true,
  meta: {
    title: 'Account',
    short: 'Account',
    icon: 'fal fa-user-circle'
  },
  class: 'bottom-0',
  children: [{
    path: 'my-profile',
    component: function component() {
      return import('@/views/account/my-profile/MyProfile');
    },
    name: 'account.my-profile',
    meta: {
      title: 'My Profile',
      icon: 'fal fa-user-circle'
    }
  }, {
    path: 'plans-billing',
    component: function component() {
      return import('@/views/account/plans-billing/PlansBilling');
    },
    name: 'account.plans-billing',
    meta: {
      title: 'Plans Billing',
      icon: 'fal fa-wallet'
    }
  }, {
    path: 'plans-home',
    component: function component() {
      return import('@/views/account/plans-billing/PlansHome');
    },
    name: 'account.plans-home',
    meta: {
      title: 'Plans Billing',
      icon: 'fal fa-wallet'
    }
  }, {
    path: 'plans-cart',
    component: function component() {
      return import('@/views/account/plans-billing/PlansCart');
    },
    name: 'account.plans-cart',
    meta: {
      title: 'Plans Cart',
      icon: 'fal fa-cart'
    }
  }, {
    path: 'notifications',
    component: function component() {
      return import('@/views/account/notifications/Notifications');
    },
    name: 'account.notifications',
    meta: {
      title: 'Notifications',
      icon: 'fal fa-bell'
    }
  }, {
    path: 'change-password',
    component: function component() {
      return import('@/views/account/change-password/ChangePassword');
    },
    name: 'account.change-password',
    meta: {
      title: 'Change Password',
      icon: 'fal fa-key'
    }
  }, {
    path: 'sign-out',
    name: 'sign-out',
    beforeEnter: function beforeEnter(to, from, next) {
      window.location.href = "".concat(process.env.VUE_APP_BASE_URL, "/logout");
    },
    // component: () => import('@/views/activity/ActivityList.vue'),
    // name: 'Sign Out',
    meta: {
      title: 'Sign Out',
      icon: 'fal fa-sign-out'
    }
  }]
}, {
  path: '/activity',
  component: function component() {
    return import('@/views/activity/ActivityView');
  },
  isGuestView: true,
  hidden: true,
  children: [{
    path: '/',
    name: 'activities',
    component: function component() {
      return import('@/views/activity/ActivityList');
    },
    meta: {
      title: 'Activities',
      icon: 'fal fa-bell'
    }
  }]
}, {
  path: '/brands',
  component: function component() {
    return import('@/views/crm/BrandList');
  },
  isGuestView: true,
  hidden: true,
  name: 'brands',
  meta: {
    title: 'Activities',
    icon: 'fal fa-bell'
  }
},
// { path: '/account/sign-out', redirect: '/auth/?redirect=' },

// 404 page must be placed at the end !!!
{
  path: '/404',
  component: function component() {
    return import('@/views/404/404');
  },
  hidden: true,
  name: '404'
}, {
  path: '*',
  redirect: '/404',
  hidden: true
}];
if (process.env.VUE_APP_APP_ID === 'kiva') {
  constantRoutes.push({
    path: 'c',
    component: function component() {
      return import('@/views/auth/AuthView');
    },
    meta: {
      title: 'Auth'
    },
    hidden: true,
    name: 'auth',
    children: [{
      path: '/',
      component: function component() {
        return import('@/views/auth/Login');
      },
      meta: {
        layout: 'GuestLayout',
        title: 'Auth'
      },
      name: 'auth.login',
      hidden: true
    }, {
      path: 'signup',
      component: function component() {
        return import('@/views/auth/SignUp');
      },
      meta: {
        layout: 'GuestLayout',
        title: 'Auth'
      },
      name: 'auth.signup',
      hidden: true
    }, {
      path: 'forgot-password',
      component: function component() {
        return import('@/views/auth/ForgotPassword');
      },
      meta: {
        layout: 'GuestLayout',
        title: 'Auth'
      },
      name: 'auth.forgotpassword',
      hidden: true
    }, {
      path: 'reset-password',
      component: function component() {
        return import('@/views/auth/ResetPassword');
      },
      meta: {
        layout: 'GuestLayout',
        title: 'Auth'
      },
      name: 'auth.resetpassword',
      hidden: true
    }, {
      path: 'session-locked',
      component: function component() {
        return import('@/views/auth/SessionLocked');
      },
      meta: {
        layout: 'GuestLayout',
        title: 'Auth'
      },
      name: 'auth.sessionlocked',
      hidden: true
    }]
  }, {
    path: '/overview/:page/:id',
    component: function component() {
      return import('@/views/overview/index');
    },
    name: 'overview',
    meta: {
      title: 'Overview',
      icon: 'fal fa-tasks-alt'
    },
    hidden: true
  },
  // {
  //   path: '/member',
  //   component: () => import('@/views/member/index'),
  //   name: 'overview.member',
  //   meta: {
  //     title: 'Member',
  //     icon: 'fal fa-user'
  //   },
  //   hidden: true,
  //   children: [{
  //     path: 'dashboard/:id',
  //     component: () => import('@/views/member/index'),
  //     name: 'MemberOverview',
  //     meta: {
  //       title: 'Member',
  //       noCache: true
  //     },
  //     hidden: true
  //   }]
  // },

  {
    path: '/'
  }, {
    path: '/dashboard',
    component: function component() {
      return import('@/views/dashboard/DasboardView');
    },
    isGuestView: true,
    name: 'dashboard',
    meta: {
      title: 'Analytics',
      short: 'Analytics',
      icon: 'kv-icon-chart'
    },
    children: [{
      path: '/',
      name: 'dashboard.home',
      component: function component() {
        return import('@/components/dashboard/overviews/workloadView');
      },
      meta: {
        title: 'Analytics',
        short: 'Analytics',
        icon: 'kv-icon-chart'
      },
      hidden: true
    }, {
      path: 'myHome',
      name: 'dashboard.myHome',
      component: function component() {
        return import('@/components/dashboard/overviews/myHome');
      },
      meta: {
        title: 'My Home',
        short: 'My Home',
        icon: 'fal fa-user'
      }
    }, {
      path: 'teamView',
      name: 'dashboard.teamView',
      component: function component() {
        return import('@/components/dashboard/overviews/teamView');
      },
      meta: {
        title: 'Team View',
        icon: 'fal fa-users'
      }
    }, {
      path: 'teamConsole',
      name: 'dashboard.teamConsole',
      component: function component() {
        return import('@/components/dashboard/overviews/teamConsole');
      },
      meta: {
        title: 'Team Console',
        icon: 'fal fa-users'
      }
    }, {
      path: 'projectPortfolio',
      name: 'dashboard.projectPortfolio',
      component: function component() {
        return import('@/components/dashboard/overviews/projectPortfolio');
      },
      meta: {
        title: 'Project Portfolio',
        icon: 'fal fa-tasks-alt'
      }
    }, {
      path: 'workloadView',
      name: 'dashboard.workloadView',
      component: function component() {
        return import('@/components/dashboard/overviews/workloadView');
      },
      meta: {
        title: 'Workload',
        icon: 'fal fa-poll-people'
      }
    }, {
      path: 'calendarView',
      name: 'dashboard.calendarView',
      component: function component() {
        return import('@/components/dashboard/overviews/calendarView');
      },
      meta: {
        title: 'Calendar View',
        short: 'Calendar',
        icon: 'kv-icon-calendar_2'
      }
    }, {
      path: 'timesheetView',
      name: 'dashboard.timesheetView',
      component: function component() {
        return import('@/components/overview/timesheet/app');
      },
      meta: {
        title: 'Timesheet',
        icon: 'fal fa-user-clock'
      }
    }, {
      path: 'projectsManagement',
      name: 'dashboard.projectsManagement',
      component: function component() {
        return import('@/components/dashboard/dashboards/projectsManagement');
      },
      meta: {
        title: 'Project Management',
        icon: 'fal fa-tasks-alt'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        var kvBaseUrl = process.env.VUE_APP_BASE_URL;
        window.open(kvBaseUrl + "/xt/dashboard/index.html?id=6&u=".concat(kvBaseUrl), "_blank");
      }
    }, {
      path: 'customerSupport',
      name: 'dashboard.customerSupport',
      component: function component() {
        return import('@/components/dashboard/dashboards/timeMaterial');
      },
      meta: {
        title: 'Customer Support',
        icon: 'far fa-life-ring'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        var kvBaseUrl = process.env.VUE_APP_BASE_URL;
        window.open(kvBaseUrl + "/xt/dashboard/index.html?id=14&u=".concat(kvBaseUrl), "_blank");
      }
    }, {
      path: 'timeMaterial',
      name: 'dashboard.timeMaterial',
      component: function component() {
        return import('@/components/dashboard/dashboards/timeMaterial');
      },
      meta: {
        title: 'Time Material',
        icon: 'fal fa-clock'
      }
    }, {
      path: 'invoicingPayments',
      name: 'dashboard.invoicingPayments',
      component: function component() {
        return import('@/components/dashboard/dashboards/invoicingPayments');
      },
      meta: {
        title: 'Invoicing Payments',
        icon: 'fal fa-file-alt'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        var kvBaseUrl = process.env.VUE_APP_BASE_URL;
        window.open(kvBaseUrl + "/xt/dashboard/index.html?id=15&u=".concat(kvBaseUrl), "_blank");
      }
    }, {
      path: 'productsServices',
      name: 'dashboard.productsServices',
      component: function component() {
        return import('@/components/dashboard/dashboards/productsServices');
      },
      meta: {
        title: 'Products & Services',
        icon: 'fal fa-database'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        var kvBaseUrl = process.env.VUE_APP_BASE_URL;
        window.open(kvBaseUrl + "/xt/dashboard/index.html?id=16&u=".concat(kvBaseUrl), "_blank");
      }
    }, {
      path: 'salesFunnel',
      name: 'dashboard.salesFunnel',
      component: function component() {
        return import('@/components/dashboard/dashboards/salesFunnel');
      },
      meta: {
        title: 'Sales Funnel',
        icon: 'fal fa-filter'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        var kvBaseUrl = process.env.VUE_APP_BASE_URL;
        window.open(kvBaseUrl + "/xt/dashboard/index.html?id=13&u=".concat(kvBaseUrl), "_blank");
      }
    }, {
      path: 'planner',
      component: function component() {
        return import('@/views/gantt/planner/index');
      },
      name: 'planner',
      meta: {
        title: 'Planner',
        icon: 'fal fa-calendar-edit'
      }
    }, {
      path: 'resources',
      component: function component() {
        return import('@/views/gantt/resources/index');
      },
      name: 'resources',
      meta: {
        title: 'Resource Planner',
        icon: 'fal fa-user',
        hideTag: true
      },
      hidden: true
    }, {
      path: 'taskPlanner',
      component: function component() {
        return import('@/views/gantt/task/index');
      },
      name: 'taskPlanner',
      meta: {
        title: 'Task Planner',
        icon: 'fal fa-user'
      }
    }]
  }, {
    path: '/showroom',
    component: function component() {
      return import('@/views/showroom/buttons');
    },
    name: 'Showroom',
    meta: {
      title: 'Showroom',
      icon: 'fal fa-home-lg-alt'
    },
    hidden: true
  }, {
    path: '/showroom2',
    component: function component() {
      return import('@/views/showroom/grid');
    },
    name: 'Showroom',
    meta: {
      title: 'Showroom',
      icon: 'fal fa-home-lg-alt'
    },
    hidden: true
  }, {
    path: '/estimate',
    isGuestView: true,
    component: function component() {
      return import('@/views/invoice/estimates/index');
    },
    name: 'estimate',
    meta: {
      title: 'Accounting',
      short: 'Accounting',
      icon: 'fal fa-calc'
    },
    children: [{
      path: 'estimates',
      component: function component() {
        return import('@/views/invoice/estimates/EstimatesList');
      },
      name: 'estimate.estimates',
      meta: {
        title: 'Estimates',
        icon: 'fal fa-shopping-cart'
      }
    }, {
      path: 'create',
      hidden: true,
      component: function component() {
        return import('@/views/invoice/estimates/EstimateCreate');
      },
      name: 'estimate.create',
      meta: {
        title: 'Invoices',
        icon: 'fal fa-file-invoice'
      },
      props: true
    }, {
      path: 'detail/:id',
      hidden: true,
      props: true,
      component: function component() {
        return import('@/views/invoice/estimates/EstimateDetail');
      },
      name: 'estimate.detail',
      meta: {
        title: 'Invoices',
        icon: 'fal fa-file-invoice'
      }
    }, {
      path: ':id',
      hidden: true,
      props: true,
      component: function component() {
        return import('@/views/invoice/estimates/EstimateCreate');
      },
      name: 'estimate.edit',
      meta: {
        title: 'Estimate',
        icon: 'fal fa-file-invoice'
      }
    }]
  }, {
    path: '/inbox',
    isGuestView: true,
    component: function component() {
      return import('@/views/inbox/InboxView');
    },
    name: 'inbox',
    meta: {
      title: 'Inbox',
      short: 'Inbox Short',
      icon: 'kv-icon-inbox'
    },
    children: [{
      path: '',
      component: function component() {
        return import('@/views/inbox/InboxList');
      },
      name: 'inbox.list',
      meta: {
        title: 'Inbox',
        short: 'Inbox Short',
        icon: 'kv-icon-inbox'
      }
    }, {
      path: 'category',
      component: function component() {
        return import('@/views/inbox/InboxCategory');
      },
      name: 'inbox.category',
      meta: {
        title: 'Categories',
        icon: 'fal fa-list-alt'
      }
    }, {
      path: ':id',
      component: function component() {
        return import('@/views/inbox/InboxDetail');
      },
      name: 'inbox.detail',
      props: true,
      hidden: true,
      meta: {
        title: 'Inbox',
        icon: 'fal fa-inbox',
        hideTag: true,
        noCache: true
      }
    }]
  }, {
    path: '/sla',
    component: function component() {
      return import('@/views/inbox/sla');
    },
    name: 'inbox.sla',
    meta: {
      title: 'SLA',
      icon: 'fal fa-inbox'
    }
  }, {
    path: '/rules',
    component: function component() {
      return import('@/views/inbox/rules');
    },
    name: 'inbox.rules',
    meta: {
      title: 'Rules',
      icon: 'fal fa-file-exclamation'
    }
  },
  // {
  //   path: '/planner',
  //   component: () => import('@/views/gantt/index'),
  //   name: 'planner',
  //   meta: {
  //     title: 'Planner',
  //     icon: 'fal fa-calendar-edit'
  //   }
  // },{
  //   path: '/resources',
  //   component: () => import('@/views/gantt/resources'),
  //   name: 'resources',
  //   meta: {
  //     title: 'Resource Planner',
  //     icon: 'fal fa-user'
  //   }
  // },
  {
    path: '/productsAndServices',
    component: function component() {
      return import('@/views/inbox/rules');
    },
    name: 'productsAndServices',
    meta: {
      title: 'Products & Services',
      short: 'Products & Services',
      icon: 'fal fa-luggage-cart'
    }
  }, {
    path: '/products',
    component: function component() {
      return import('@/views/products/ProductView');
    },
    isGuestView: false,
    name: 'products',
    meta: {
      title: 'Products & Services',
      icon: 'fal fa-luggage-cart'
    },
    children: [{
      path: 'list',
      component: function component() {
        return import('@/views/products/ProductsList');
      },
      name: 'products.list',
      meta: {
        title: 'Products & Services',
        roles: ['admin'],
        icon: 'fal fa-luggage-cart'
      }
    }, {
      path: 'category',
      component: function component() {
        return import('@/views/products/ProductsCategory');
      },
      name: 'products.category',
      meta: {
        title: 'Product Categories',
        roles: ['admin'],
        icon: 'fal fa-stream'
      }
    }, {
      path: '/products/:tab',
      name: 'products.tab',
      isGuestView: false,
      hidden: true,
      meta: {
        title: 'Products',
        keywords: "project,görevler,kanban",
        icon: 'kv-icon-task'
      },
      component: function component() {
        return import('@/views/products/ProductsList');
      }
    }]
  }, {
    path: '/crm',
    component: function component() {
      return import('@/views/crm/CrmView');
    },
    isGuestView: false,
    name: 'crm',
    meta: {
      title: 'CRM',
      icon: 'fal fa-address-book'
    },
    children: [{
      path: 'leads',
      component: function component() {
        return import('@/views/crm/LeadIndex');
      },
      name: 'crm.leads',
      meta: {
        title: 'Leads',
        short: 'Leads',
        keywords: "leads,fırsatlar,satış,sales",
        roles: ['admin'],
        icon: 'kv-icon-lead'
      }
    }, {
      path: 'leads/:page',
      component: function component() {
        return import('@/views/crm/LeadIndex');
      },
      name: 'crm.lealsPage',
      hidden: true,
      meta: {
        title: 'Leads',
        short: 'Leads',
        roles: ['admin'],
        icon: 'kv-icon-lead'
      }
    }, {
      path: 'lead/:id',
      component: function component() {
        return import('@/views/crm/LeadDetail');
      },
      name: 'crm.lead',
      hidden: true,
      meta: {
        title: 'Leads',
        roles: ['admin'],
        icon: 'kv-icon-lead'
      }
    }, {
      path: 'deals',
      component: function component() {
        return import('@/views/crm/DealIndex');
      },
      name: 'crm.deals',
      meta: {
        title: 'Deals',
        short: 'Deals',
        keywords: "deals,fırsatlar,satış,sales",
        roles: ['admin'],
        icon: 'kv-icon-deals'
      }
    }, {
      path: 'deals/:page',
      component: function component() {
        return import('@/views/crm/DealIndex');
      },
      name: 'crm.dealsPage',
      hidden: true,
      meta: {
        title: 'Deals',
        short: 'Deals',
        roles: ['admin'],
        icon: 'kv-icon-deals'
      }
    }, {
      path: 'deal/:id',
      component: function component() {
        return import('@/views/crm/DealDetail');
      },
      name: 'crm.deal',
      hidden: true,
      meta: {
        title: 'Deal',
        roles: ['admin'],
        icon: 'fal fa-bullseye-arrow '
      }
    }, {
      path: 'accounts',
      component: function component() {
        return import('@/views/crm/AccountIndex');
      },
      name: 'crm.accounts',
      meta: {
        roles: ['admin'],
        short: 'Accounts',
        title: 'Accounts',
        keywords: "Accounts,hesaplar,müşteriler,firmalar,şirketler",
        icon: 'fal fa-building'
      }
    }, {
      path: 'tasks',
      component: function component() {
        return import('@/views/crm/Tasks');
      },
      name: 'crm.tasks',
      meta: {
        title: 'Projects',
        short: 'Projects',
        keywords: "tasks,görevler,kanban",
        roles: ['admin'],
        icon: 'fal fa-tasks'
      }
    }, {
      path: 'account/:id',
      component: function component() {
        return import('@/views/crm/AccountDetail');
      },
      name: 'crm.accountDetail',
      hidden: true,
      meta: {
        title: 'Organizations / Companies',
        roles: ['admin'],
        icon: 'fal fa-building'
      }
    }, {
      path: 'contacts',
      component: function component() {
        return import('@/views/crm/ContactIndex');
      },
      name: 'crm.contacts',
      meta: {
        title: 'Contacts',
        short: 'Contacts',
        keywords: "contacts,kişiler,kontaktlar",
        roles: ['admin'],
        icon: 'fal fa-id-card'
      }
    }, {
      path: 'contracts',
      component: function component() {
        return import('@/views/crm/ContractIndex');
      },
      name: 'crm.contract',
      meta: {
        title: 'Contracts',
        keywords: "contracts,kontraktlar,bağlantılar",
        roles: ['admin'],
        icon: 'fal fa-file-contract'
      }
    }]
  },
  // {
  //   path: '/tasks',
  //   name: 'tasks',
  //   isGuestView: true,
  //   hidden: true,

  //   meta: {
  //     title: 'Tasks',
  //     keywords:"tasks,görevler,kanban",

  //     icon: 'kv-icon-task'
  //   },
  //   component: () => import('@/views/tasks/TaskView'),
  //   children: [
  //       {
  //         path: '/',
  //         component: () => import('@/views/tasks/index.vue'),
  //         name: 'Tasks',
  //         meta: {
  //           title: 'Tasks',
  //           keywords:"tasks,görevler,kanban",

  //           icon: 'kv-icon-task'
  //         }
  //       }]
  // },{
  //   path: '/tasks/:id',
  //   name: 'tasks.id',
  //   isGuestView: true,
  //   hidden: true,

  //   meta: {
  //     title: 'Tasks',
  //     keywords:"tasks,görevler,kanban",

  //     icon: 'kv-icon-task'
  //   },
  //   component: () => import('@/views/tasks/TaskView'),
  //   children: [{
  //     path: '/',
  //     component: () => import('@/views/tasks/index.vue'),
  //     name: 'Tasks',
  //     meta: {
  //       title: 'Tasks',
  //       keywords:"tasks,görevler,kanban",
  //       icon: 'kv-icon-task'
  //     }
  //   }]
  // },{
  //   path: '/tasks/:id/:tab',
  //   name: 'tasks.id.tab',
  //   isGuestView: true,
  //   hidden: true,

  //   meta: {
  //     title: 'Tasks',
  //     keywords:"tasks,görevler,kanban",

  //     icon: 'kv-icon-task'
  //   },
  //   component: () => import('@/views/tasks/TaskView'),
  //   children: [{
  //     path: '/',
  //     component: () => import('@/views/tasks/index.vue'),
  //     name: 'Tasks',
  //     meta: {
  //       title: 'Tasks',
  //       keywords:"tasks,görevler,kanban",

  //       icon: 'kv-icon-task'
  //     }
  //   }]
  // },

  {
    path: '/project',
    name: 'project',
    isGuestView: true,
    hidden: false,
    meta: {
      title: 'Projects',
      keywords: "proje,görevler,kanban",
      icon: 'kv-icon-task'
    },
    component: function component() {
      return import('@/views/project/index');
    }
  }, {
    path: '/projectPlan',
    name: 'projectPlan',
    isGuestView: true,
    hidden: false,
    meta: {
      title: 'Project Plan',
      keywords: "proje,görevler,kanban",
      icon: 'kv-icon-task'
    },
    component: function component() {
      return import('@/views/project/project_plans');
    }
  }, {
    path: '/project/:id',
    name: 'project.id',
    isGuestView: true,
    hidden: true,
    meta: {
      title: 'Project',
      keywords: "tasks,görevler,kanban",
      icon: 'kv-icon-task'
    },
    component: function component() {
      return import('@/views/project/index');
    }
  }, {
    path: '/project/:id/:tab',
    name: 'project.id.tab',
    isGuestView: true,
    hidden: true,
    meta: {
      title: 'Project',
      keywords: "project,görevler,kanban",
      icon: 'kv-icon-task'
    },
    component: function component() {
      return import('@/views/project/index');
    }
  }, {
    path: '/project/:id/:tab/:view',
    name: 'project.id.tab.view',
    isGuestView: true,
    hidden: true,
    meta: {
      title: 'Project',
      keywords: "project,görevler,kanban",
      icon: 'kv-icon-task'
    },
    component: function component() {
      return import('@/views/project/index');
    }
  }, {
    path: '/mywork',
    name: 'mywork',
    isGuestView: true,
    component: function component() {
      return import('@/views/tasks/TaskView');
    },
    meta: {
      title: 'My Work',
      keywords: "console,focus,konsol",
      short: 'My Work',
      icon: 'kv-icon-console'
    },
    children: [{
      path: '/',
      component: function component() {
        return import('@/views/tasks/focus.vue');
      },
      name: 'MyWork',
      meta: {
        title: 'My Work',
        short: 'My Work',
        keywords: "console,focus,konsol",
        icon: 'kv-icon-console'
      }
    }]
  }, {
    path: '/team',
    name: 'team',
    isGuestView: true,
    hidden: false,
    meta: {
      title: 'Teams',
      keywords: "takım,görevler,kanban",
      icon: 'fal fa-user-friends'
    },
    component: function component() {
      return import('@/views/team/index');
    }
  }, {
    path: '/team/:id',
    name: 'team.id',
    isGuestView: true,
    hidden: true,
    meta: {
      title: 'Teams',
      keywords: "tasks,görevler,kanban",
      icon: 'kv-icon-task'
    },
    component: function component() {
      return import('@/views/team/index');
    }
  }, {
    path: '/team/:id/:tab',
    name: 'team.id.tab',
    isGuestView: true,
    hidden: true,
    meta: {
      title: 'Teams',
      keywords: "team,görevler,kanban",
      icon: 'kv-icon-task'
    },
    component: function component() {
      return import('@/views/team/index');
    }
  }, {
    path: '/team/:id/:tab/:view',
    name: 'team.id.tab.view',
    isGuestView: true,
    hidden: true,
    meta: {
      title: 'Project',
      keywords: "team,görevler,kanban",
      icon: 'kv-icon-task'
    },
    component: function component() {
      return import('@/views/team/index');
    }
  }, {
    path: '/manage',
    component: function component() {
      return import('@/views/manage/ManageView');
    },
    isGuestView: false,
    name: 'manage',
    meta: {
      title: 'Manage',
      icon: 'fal fa-users'
    },
    children: [{
      path: 'teams',
      component: function component() {
        return import('@/views/manage/teams/TeamsList');
      },
      name: 'manage.teams',
      meta: {
        title: 'Teams',
        roles: ['admin'],
        icon: 'fal fa-users-crown'
      }
    }, {
      path: 'timeoff',
      component: function component() {
        return import('@/views/manage/timeoff/TimeoffList');
      },
      name: 'manage.timeoff',
      meta: {
        title: 'Timeoff',
        roles: ['admin'],
        icon: 'fal fa-island-tropical'
      }
    }, {
      path: 'overtime',
      component: function component() {
        return import('@/views/manage/overtime/OvertimeList');
      },
      name: 'manage.overtime',
      meta: {
        title: 'Overtime',
        roles: ['admin'],
        icon: 'fal fa-calendar-plus'
      }
    }]
  }, {
    path: '/invoices',
    component: function component() {
      return import('@/views/invoice/InvoiceView');
    },
    isGuestView: false,
    name: 'invoice',
    meta: {
      title: 'Invoices',
      icon: 'fal fa-file-invoice'
    },
    children: [{
      path: '/',
      component: function component() {
        return import('@/views/invoice/invoices/InvoicesList');
      },
      name: 'invoice.invoices',
      meta: {
        title: 'Invoices',
        icon: 'fal fa-file-invoice'
      }
    }, {
      path: 'create',
      hidden: true,
      component: function component() {
        return import('@/views/invoice/invoices/InvoiceCreate');
      },
      name: 'invoice.invoices.create',
      meta: {
        title: 'Invoices',
        icon: 'fal fa-file-invoice'
      },
      props: true
    }, {
      path: 'detail/:id',
      hidden: true,
      props: true,
      component: function component() {
        return import('@/views/invoice/invoices/InvoiceDetail');
      },
      name: 'invoice.invoices.detail',
      meta: {
        title: 'Invoices',
        icon: 'fal fa-file-invoice'
      }
    }, {
      path: 'payments',
      component: function component() {
        return import('@/views/invoice/payments/PaymentsList');
      },
      name: 'invoice.payments',
      meta: {
        title: 'Payments',
        icon: 'fal fa-money-bill-wave'
      }
    }, {
      path: 'expenses',
      component: function component() {
        return import('@/views/invoice/expenses/ExpensesList');
      },
      name: 'invoice.expenses',
      meta: {
        title: 'Expenses',
        icon: 'fal fa-money-bill-wave'
      }
    }, {
      path: 'time-expense-reports',
      component: function component() {
        return import('@/views/invoice/time-and-expense-reports/TimeAndExpenseView');
      },
      name: 'invoice.time-and-expense-reports',
      meta: {
        title: 'Time & Expense Reports',
        icon: 'fal fa-calculator'
      },
      children: [{
        path: '/',
        hidden: true,
        component: function component() {
          return import('@/views/invoice/time-and-expense-reports/TimeAndExpenseReportsList.vue');
        },
        name: 'invoice.time-and-expense-reports',
        meta: {
          title: 'Time & Expense Reports',
          icon: 'fal fa-calculator'
        }
      }, {
        path: 'detail',
        hidden: true,
        component: function component() {
          return import('@/views/invoice/time-and-expense-reports/TimeAndExpenseReportDetail');
        },
        name: 'invoice.time-and-expense-reports.detail',
        meta: {
          title: 'Time & Expense Report',
          icon: 'fal fa-calculator'
        }
      }, {
        path: 'print',
        hidden: true,
        component: function component() {
          return import('@/views/invoice/time-and-expense-reports/TimeAndExpenseReportPrint');
        },
        name: 'invoice.time-and-expense-reports.print',
        meta: {
          title: 'Time & Expense Report',
          icon: 'fal fa-calculator'
        }
      }]
    }, {
      path: 'hourly-rate-lists',
      component: function component() {
        return import('@/views/invoice/hourly-rate-lists/HourlyRateLists');
      },
      name: 'settings.hourly-rate-lists',
      meta: {
        noCache: true,
        title: 'Hourly Rate Lists',
        icon: 'fal fa-user-tag'
      }
    }, {
      path: ':id',
      hidden: true,
      component: function component() {
        return import('@/views/invoice/invoices/InvoiceCreate');
      },
      name: 'invoice.invoices.edit',
      meta: {
        title: 'Invoices',
        icon: 'fal fa-file-invoice'
      },
      props: true
    }]
  }, {
    path: '/documents',
    component: function component() {
      return import('@/views/documents/DocumentsIndex');
    },
    name: 'alldocuments',
    isGuestView: false,
    meta: {
      title: 'Documents',
      short: 'Docs',
      icon: 'kv-icon-docs'
    },
    children: [{
      component: function component() {
        return import('@/views/documents/DocumentsView');
      },
      path: '/',
      name: 'Docs',
      meta: {
        title: 'Documents & Pages',
        short: 'Docs',
        icon: 'kv-icon-docs'
      },
      children: [{
        path: '',
        component: function component() {
          return import('@/views/documents/DocumentsList.vue');
        },
        name: 'Documents',
        meta: {
          title: 'Documents',
          short: 'Docs',
          icon: 'kv-icon-docs'
        }
      }]
    }, {
      path: 'pages',
      component: function component() {
        return import('@/views/pages/pagesView.vue');
      },
      name: 'pages',
      meta: {
        title: 'Pages',
        icon: 'kv-icon-pages'
      }
    }, {
      path: 'pages-wide',
      component: function component() {
        return import('@/views/pages/pagesViewWide.vue');
      },
      name: 'pagesWide',
      meta: {
        title: 'Pages',
        icon: 'kv-icon-pages',
        layout: 'FullScreenLayout'
      }
    }, {
      path: '/tiptap',
      component: function component() {
        return import('@/views/pages/tiptap.vue');
      },
      name: 'Tiptap',
      meta: {
        title: 'Tiptap',
        icon: 'fal fa-file-alt'
      },
      hidden: true
    }]
  }, {
    path: '/reports',
    component: function component() {
      return import('@/views/reports/reportsView');
    },
    name: 'ReportsPage',
    isGuestView: false,
    meta: {
      title: 'Reports',
      short: 'Reports',
      icon: 'fal fa-analytics'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      var kvBaseUrl = process.env.VUE_APP_BASE_URL;
      window.open(kvBaseUrl + "/xt/reports/index.html?u=".concat(kvBaseUrl), "_blank");
    },
    children: [{
      path: '/',
      name: 'ReportsPage.Reports',
      component: function component() {
        return import('@/views/reports/table.vue');
      },
      meta: {
        title: 'Reports',
        icon: 'fal fa-analytics'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        var kvBaseUrl = process.env.VUE_APP_BASE_URL;
        window.open(kvBaseUrl + "/xt/reports/index.html?u=".concat(kvBaseUrl), "_blank");
      }
    }]
  }, {
    path: '/dashboards',
    component: function component() {
      return import('@/views/reports/dashboardView');
    },
    name: 'DashboardPage',
    isGuestView: false,
    meta: {
      title: 'Dashboard',
      short: 'Dashboard',
      icon: 'fal fa-folder-tree'
    },
    children: [{
      path: '/',
      name: 'Dashboards',
      component: function component() {
        return import('@/views/reports/table.vue');
      },
      meta: {
        title: 'Dashboards',
        icon: 'fal fa-analytics'
      }
    }]
  }, {
    path: '/settings',
    class: 'bottom-0',
    isGuestView: false,
    name: 'settings',
    component: function component() {
      return import('@/views/settings/SettingsView');
    },
    meta: {
      hideTag: true,
      noCache: true,
      title: 'Settings',
      short: 'Settings',
      icon: 'kv-item-settings'
    },
    children: [{
      path: 'account-information',
      component: function component() {
        return import('@/views/settings/account-information/AccountInformation');
      },
      name: 'settings.account-information',
      pathFull: '/settings/account-information',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Account Information',
        icon: 'fal fa-industry'
      }
    }, {
      path: 'billing-information',
      component: function component() {
        return import('@/views/settings/billing-information/BillingInformation');
      },
      name: 'settings.billing-information',
      pathFull: '/settings/billing-information',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Billing Information',
        icon: 'fal fa-file-invoice'
      }
    }, {
      path: 'users',
      component: function component() {
        return import('@/views/settings/users/Users');
      },
      name: 'settings.users',
      pathFull: '/settings/users',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Users',
        icon: 'fal fa-users-cog'
      }
    }, {
      path: 'groups',
      component: function component() {
        return import('@/views/settings/groups/Groups');
      },
      name: 'settings.groups',
      pathFull: '/settings/groups',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Groups',
        icon: 'fal fa-users'
      }
    }, {
      path: 'subscription-information',
      component: function component() {
        return import('@/views/settings/plans-billing/PlansBilling');
      },
      name: 'settings.subscription-information',
      pathFull: '/settings/subscription-information',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Subscriptions',
        icon: 'fal fa-shopping-cart'
      }
    }, {
      path: 'invoice-payments',
      component: function component() {
        return import('@/views/settings/invoice-payments/InvoicePayments');
      },
      name: 'settings.invoice-payments',
      pathFull: '/settings/invoice-payments',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Invoices and Payments',
        icon: 'fal fa-money-check'
      }
    }, {
      path: 'currency',
      component: function component() {
        return import('@/views/settings/currency/Currency');
      },
      name: 'settings.currency',
      pathFull: '/settings/currency',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Currency',
        icon: 'fal fa-money-bill-wave'
      }
    }, {
      path: 'preferences',
      component: function component() {
        return import('@/views/settings/preferences/Preferences');
      },
      name: 'settings.preferences',
      pathFull: '/settings/preferences',
      meta: {
        title: 'Preferences',
        icon: 'fal fa-sliders-h-square'
      }
    }, {
      path: 'integrations',
      component: function component() {
        return import('@/views/settings/integrations/Integrations');
      },
      name: 'settings.integrations',
      pathFull: '/settings/integrations',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Integrations',
        icon: 'fal fa-sync-alt'
      }
    }, {
      path: 'export-data',
      component: function component() {
        return import('@/views/settings/export-data/ExportData');
      },
      name: 'settings.export-data',
      pathFull: '/settings/export-data',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Export Data',
        icon: 'fal fa-folder-download'
      }
    }, {
      path: 'email-settings',
      component: function component() {
        return import('@/views/settings/email-settings/EmailSettings');
      },
      name: 'settings.email-settings',
      pathFull: '/settings/email-settings',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Email Settings',
        icon: 'fal fa fa-envelope'
      }
    }, {
      path: 'customer-portal-settings',
      component: function component() {
        return import('@/views/settings/customer-portal-settings/CustomerPortalSettings');
      },
      name: 'settings.customer-portal-settings',
      pathFull: '/settings/customer-portal-settings',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Customer Portal Settings',
        icon: 'kv-icon-customer-portal-settings'
      }
    }, {
      path: 'email-template',
      component: function component() {
        return import('@/views/settings/email-template/EmailTemplate');
      },
      name: 'settings.email-template',
      pathFull: '/settings/email-template',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Email Templates',
        icon: 'kv-icon-email-template'
      }
    }, {
      path: 'print-pdf-template',
      component: function component() {
        return import('@/views/settings/print-pdf-template/PrintPdfTemplate');
      },
      name: 'settings.print-pdf-template',
      pathFull: '/settings/print-pdf-template',
      meta: {
        hideTag: true,
        noCache: true,
        title: 'Print & PDF Template',
        icon: 'kv-icon-print-pdf-template'
      }
    }, {
      path: '/licenseConfigrator',
      component: function component() {
        return import('@/views/settings/licenseConfigrator');
      },
      hidden: true,
      pathFull: '/licenseConfigrator',
      meta: {
        title: 'License Configrator',
        icon: 'fal fa-sliders-h'
      }
    }]
  });
}
var createRouter = function createRouter() {
  return new Router({
    mode: 'history',
    // require service support
    linkExactActiveClass: 'is-exact-active',
    linkActiveClass: 'is-active',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
      if (to.matched.some(function (m) {
        return m.meta.disableScroll;
      })) return;
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export function addExtendedRoutes(newRoutes) {
  var routes = router.options.routes;
  routes.push.apply(routes, _toConsumableArray(newRoutes));
  router.addRoutes(newRoutes);
  broadcast.$emit('route:updated');
}
export default router;